import React from 'react';
import { Intent } from '@blueprintjs/core/src/common/intent';
import { Spinner } from '@blueprintjs/core';

export const Loader = ({ size = 50, intent = 'primary' }: { size?: number; intent?: Intent }) => (
  <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
    <Spinner intent={intent} size={size} />
  </div>
);
